import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

dayjs.extend(relativeTime);
dayjs.extend(utc);

const HAS_TIMEZONE_SUFFIX = /(Z|[+-]\d{2}:\d{2}|[+-]\d{4})$/i;

const normalizeDateString = (dateString: string) => {
  const value = dateString.trim();

  if (!value) {
    return "";
  }

  if (value.includes("T")) {
    return HAS_TIMEZONE_SUFFIX.test(value) ? value : `${value}Z`;
  }

  return `${value} UTC`;
};

export const parseServerDate = (dateString?: string) => {
  if (!dateString?.trim()) {
    return null;
  }

  const parsedDate = dayjs(normalizeDateString(dateString));

  if (!parsedDate.isValid()) {
    return null;
  }

  return parsedDate.local();
};

export const formatTimeAgo = (dateString?: string, format?: string) => {
  const localDate = parseServerDate(dateString);

  if (!localDate) {
    return "";
  }

  return format ? localDate.format(format) : localDate.fromNow();
};

export const formatLocalDateTime = (
  dateString?: string,
  format = "MMM D, YYYY h:mm A",
) => {
  const localDate = parseServerDate(dateString);

  if (!localDate) {
    return "";
  }

  return localDate.format(format);
};
